class StickyHeader {
  constructor() {
    this.header = document.getElementById('js-sticky-header')
    this.scrollPoint = 0
    this.lastPoint = 0
    this.scrollEvent()
  }
  
  scrollEvent() {
    window.addEventListener('scroll', () => {
      this.scrollPoint = window.scrollY;
    
      if (this.scrollPoint > this.lastPoint){
        // 下スクロールの場合
        this.header.classList.add('-is-hide');
      } else {
        // 上スクロールの場合
        this.header.classList.remove('-is-hide');
      }
      
      this.lastPoint = this.scrollPoint;
    })
  }
}

new StickyHeader()

// const fixedElm = document.getElementById('js-sticky-header');
// let scrollPoint = 0; // 現在のスクロール位置をセットする変数
// let lastPoint = 0; // 1つ前のスクロール位置をセットする変数

// console.log(fixedElm)

// window.addEventListener("scroll",function(){
  
//   scrollPoint = window.scrollY;
  
//   if(scrollPoint > lastPoint){ // 下スクロールの場合
//     fixedElm.classList.add('-is-hide');
//   }else{ // 上スクロールの場合
//     fixedElm.classList.remove('-is-hide');
//   }
  
//   lastPoint = scrollPoint;
// });
